class Confirmation {
    constructor($el) {
        this.$el = $el;
        this.message = this.$el.data('message');

        this.init();
    }

    init = () => {
        this.$el.on('click', this.clickHandler);
    }

    clickHandler = (e) => {
        if (!confirm(this.message)) {
            e.preventDefault();
        }
    }
}

export default Confirmation;
